import { createContext } from 'react';

function createNamedContext(name, defaultValue) {
    const NamedContext = createContext(defaultValue);
    NamedContext.displayName = name;
    return NamedContext;
}

export { createNamedContext };
//# sourceMappingURL=createNamedContext.mjs.map
